<template>
  <div style="padding: 10px; border-right: 1px solid rgba(0,0,0,.12); background-color: #fff;">
    <div :style="`position: fixed !important; width: 240px !important;`" >
      <template v-if="$route.name === 'methodology'">
        <h3>Table of Contents</h3>
        <v-divider class="mb-2"></v-divider>
        <div class="toc-item"><a href="#overview">Overview</a></div>
        <div class="toc-item"><a href="#summary">Summary of the Methodology</a></div>
        <div class="toc-item"><a href="#datasets">Dataset and Variables</a></div>
        <div class="toc-item"><a href="#prediction_framework">Prediction Framework</a></div>
        <div class="toc-item"><a href="#feature_selection">Feature Selection</a></div>
        <div class="toc-item"><a href="#algorithms">Algorithms</a></div>
        <div class="toc-item"><a href="#polls">Polls</a></div>
        <div class="toc-item"><a href="#election_simulations">Election Simulations</a></div>
      </template>
      <template v-else-if="$route.name === 'calculator'">
        <calculator-toolbar></calculator-toolbar>
      </template>
      <template v-else>
        <h4 class="toolbar-heading">Filter by Date</h4>
        <date-select :toolbar="true"></date-select>
        <v-divider style="margin: 10px 0;"></v-divider>
        <h4 class="toolbar-heading">Search by Race</h4>
        <seat-search :toolbar="true"></seat-search>
      </template>
    </div>
  </div>
</template>

<script>
import { CalculatorToolbar, DateSelect, SeatSearch } from '@/components/common'

const components = {
  CalculatorToolbar,
  DateSelect,
  SeatSearch
}

export default {
  components
}
</script>

<style>
.toc-item {
  text-align: start;
  margin-bottom: 10px;
}

.toc-item a {
  color: #333 !important;
  font-weight: 400;
  letter-spacing: 0.02em;
}

.toolbar-heading {
  text-align: center;
  margin-top: 20px;
}

.mode-button {
  display: block;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/Toolbar.vue